<template lang="pug">
v-dialog(v-model="dialog" max-width="300px")
  v-card
    v-card-title Confirm delete?
    v-card-text This action cannot be undone
    v-card-actions
      v-spacer
      v-btn(text @click="dialog = false") Cancel
      v-btn(color="error" @click="$emit('confirm')") Delete
</template>

<script>
export default {
  name: "DeleteDialog",
  props: ['value'],
  data: () => ({
    dialog: false
  }),
  watch: {
    value (val) {
      this.dialog = val
    },
    dialog (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>